package com.kinoshazam.model

enum class AppLanguage(val locale: String, val lang: String) {
    EN(locale = "en", lang = "English"),
//    PT(locale = "pt", lang = "Portuguese"),
    RU(locale = "ru", lang = "Русский");

    companion object {
        fun fromCode(code: String?): AppLanguage =
            entries.find { it.locale == code } ?: EN
    }
}